import { Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { PermissionUtils } from 'utils'
import homeRoutes from 'modules/Home/routing/routes'
import EventDetailsRouting, {
  routes as eventDetailsRoutes,
} from 'modules/virtualClassrooms/student/EventDetails/routing'
import EventsRouting from 'modules/virtualClassrooms/student/Events/routing'
import ParticipantScheduleDetailsRouting, {
  routes as participantScheduleDetailsRoutes,
} from 'modules/virtualClassrooms/student/ParticipantScheduleDetails/routing'
import PresenterScheduleDetailsRouting, {
  routes as presenterScheduleDetailsRoutes,
} from 'modules/virtualClassrooms/student/PresenterScheduleDetails/routing'
import routes from './studentRoutes'

const { RouteChangeProgress } = common

export { routes }

const StudentRouting = () => {
  const virtualClassroomDenied = PermissionUtils.virtualClassroomDenied()
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <Switch>
        <PrivateRoute
          path={eventDetailsRoutes.root}
          component={EventDetailsRouting}
          disabled={virtualClassroomDenied}
        />
        <PrivateRoute
          path={participantScheduleDetailsRoutes.root}
          component={ParticipantScheduleDetailsRouting}
          disabled={virtualClassroomDenied}
        />
        <PrivateRoute
          path={presenterScheduleDetailsRoutes.root}
          component={PresenterScheduleDetailsRouting}
          disabled={virtualClassroomDenied}
        />
        <PrivateRoute
          path={routes.root}
          component={EventsRouting}
          disabled={virtualClassroomDenied}
        />
        <Redirect path='*' to={homeRoutes.root} />
      </Switch>
    </Suspense>
  )
}

export default StudentRouting
